import React from "react";
import { useLang } from "../context/LanguageContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c61eb3a6-eca5-4227-9115-b8ca96405a47/artifacts/zd13mtbj_F429A9FE-5AF6-4B77-9FE8-06E1627EDB41.PNG";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 px-6 md:px-12 py-16 md:py-20"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-8">
            <p className="font-editorial italic font-light text-3xl md:text-5xl lg:text-6xl text-zinc-500 leading-tight">
              {t.footer.tagline}
            </p>
          </div>
          <div className="col-span-12 md:col-span-4 flex md:justify-end items-end">
            <img src={LOGO_URL} alt="Salside.Production" className="h-20 w-20 object-contain" />
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <p className="text-7xl md:text-8xl chrome-text font-display tracking-tighter">SALSIDE</p>
            <p className="font-mono-tight text-zinc-600 mt-2">.PRODUCTION</p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="font-mono-tight text-zinc-600 mb-4">Index</p>
            <ul className="space-y-2 text-zinc-400 text-sm">
              <li><a href="#about" className="hover:text-white">{t.about.label.replace(/^\d+\s*/, "")}</a></li>
              <li><a href="#collective" className="hover:text-white">{t.collective.label.replace(/^\d+\s*/, "")}</a></li>
              <li><a href="#services" className="hover:text-white">{t.services.label.replace(/^\d+\s*/, "")}</a></li>
              <li><a href="#work" className="hover:text-white">{t.portfolio.label.replace(/^\d+\s*/, "")}</a></li>
              <li><a href="#process" className="hover:text-white">{t.process.label.replace(/^\d+\s*/, "")}</a></li>
              <li><a href="#book" className="hover:text-white">{t.booking.label.replace(/^\d+\s*/, "")}</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="font-mono-tight text-zinc-600 mb-4">Connect</p>
            <ul className="space-y-2 text-zinc-400 text-sm">
              <li><a href="https://www.instagram.com/salside.production" target="_blank" rel="noopener noreferrer" className="hover:text-white">Instagram</a></li>
              <li><a href="https://wa.me/33627568937" className="hover:text-white">WhatsApp</a></li>
              <li><a href="mailto:salside.pro@gmail.com" className="hover:text-white">Email</a></li>
            </ul>
          </div>
          <div className="col-span-12 md:col-span-2">
            <p className="font-mono-tight text-zinc-600 mb-4">Legal</p>
            <ul className="space-y-2 text-zinc-400 text-sm">
              <li><a href="/admin/login" className="hover:text-white" data-testid="admin-link">Admin</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 font-mono-tight text-zinc-600 text-xs">
          <span>© {year} SALSIDE.PRODUCTION · {t.footer.rights}</span>
          <span>{t.footer.group} · Paris, France</span>
        </div>
      </div>
    </footer>
  );
}
